exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body .slimScrollDiv {\n  height: 350px !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/pakornduangtrakan/Snocko/other/backend-auto/src/app/pages/Nlogin/login.component.css
// module id = ../../../../../src/app/pages/Nlogin/login.component.css
// module chunks = login.module.0